export default function ServiceScope() {
  return (
    <section className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">対応工事範囲</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-xl shadow-lg p-4 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3 overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/231654e7dadf8930495adf7f66e6eece.jpg" 
                alt="配線工事" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-sm font-bold text-green-900 mb-1">配線工事</h3>
            <p className="text-xs text-green-600">住宅・店舗の基本配線</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-4 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=icon%2C%20Industrial%20electrical%20panel%2C%20realistic%20electrical%20control%20panel%20and%20switches%2C%20high-detail%203D%20rendering%2C%20prominent%20main%20subjects%2C%20clear%20and%20sharp%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20soft%20lighting%2C%20subtle%20shadows&width=48&height=48&seq=panel001&orientation=squarish" 
                alt="電気設備工事" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-sm font-bold text-green-900 mb-1">電気設備工事</h3>
            <p className="text-xs text-green-600">工場・ビルの設備工事</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-4 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=icon%2C%20Maintenance%20tools%2C%20realistic%20electrical%20maintenance%20equipment%20and%20tools%2C%20high-detail%203D%20rendering%2C%20prominent%20main%20subjects%2C%20clear%20and%20sharp%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20soft%20lighting%2C%20subtle%20shadows&width=48&height=48&seq=maintenance001&orientation=squarish" 
                alt="保守メンテナンス" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-sm font-bold text-green-900 mb-1">保守メンテナンス</h3>
            <p className="text-xs text-green-600">定期点検・緊急対応</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-4 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=icon%2C%20High%20voltage%20electricity%2C%20realistic%20high%20voltage%20electrical%20equipment%20and%20transformers%2C%20high-detail%203D%20rendering%2C%20prominent%20main%20subjects%2C%20clear%20and%20sharp%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20soft%20lighting%2C%20subtle%20shadows&width=48&height=48&seq=highvolt001&orientation=squarish" 
                alt="高圧工事" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-sm font-bold text-green-900 mb-1">高圧工事</h3>
            <p className="text-xs text-green-600">大型案件・特殊工事</p>
          </div>
        </div>
      </div>
    </section>
  );
}
